<template>
    <div class="m-modal-wrapper" ref="modal" v-if="show" @touchmove.prevent @mousewheel.prevent @click="closeWinBg">
        <div class="m-modal-container">
            <div class="modal m-video-modal" ref="videoModal">
                <div class="modal_header">
                    <span class="close" @click="closeWin"></span>
                </div>
                <div v-if="!isIe">
                    <video controls preload="none" class="videoInfo-video" ref="videoref" :id="'videoPlayer_'+videoInfo.id" :poster="videoInfo.coverImageRealPath"  :src="videoInfo.url"  width="896" height="510" autoplay>
                    </video>
                </div>
                <div v-if="isIe" id="videoPlayerBox">
                    <video controls preload="none" class="videoInfo-video" ref="videoref" id="videoPlayer_embed" :poster="videoInfo.coverImageRealPath"  :src="videoInfo.url"  width="896" height="510" autoplay>
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "video-modal",
        props: {
            videoInfo: {
                default() {
                    return {}
                }
            },
            show: {
                default: false
            }
        },
        data() {
            return {
                isIe: !!window.ActiveXObject || "ActiveXObject" in window?true:false
                // isIe: true
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            closeWinBg(ev) {
                if (!this.$refs.videoModal||!this.$refs.videoModal.contains(ev.target)) {
                    this.closeWin();
                }

            },
            closeWin() {
                // if(this.isIe){
                //     let parent = document.getElementById('videoPlayerBox');
                //     let child = document.getElementById('videoPlayer_embed');
                //     parent.removeChild(child);
                // }
                this.$emit('closeModal')
            },
        },
    }
</script>

<style lang="scss">
    @import "../assets/scss/video/modal";
    .videoInfo-video{
        width:100%;
        height:auto;
    }
</style>
